import router from '@/router';
import authService from "@/services/authService";
import toastService from '@/services/toastService';
import {clearCache} from '@/services/cache';

export default {
  state:{
    token:localStorage.token,
    role:localStorage.role,
  },
  getters:{
    token: state => state.token,
    refreshToken: state => state.refreshToken,
    loggedIn: state => !(state.token == null || state.token == ''),
    role: state => state.role,
    isReadOnly: state => state.role === 'ROLE_READONLY',
    canWrite: state => state.role !== 'ROLE_READONLY'
  },
  mutations:{
    setTokenAndRefreshToken: (state,token) => {
      localStorage.token = token;
      state.token = token;
    },
    setRole: (state,role) => {
      localStorage.role = role || "";
      state.role = role || "";
    },
    logOut:state => {
      state.token = "";
      state.refreshToken = "";
      state.role = "";
      localStorage.token = "";
      localStorage.role = "";
    }
  },
  actions:{
    login:({commit},payload) =>{
      authService.login(payload, (data) => {
        commit('setTokenAndRefreshToken', data.accessToken);
        commit('setRole', data.role);
        toastService.showSuccessToast("Login successful");
        router.push('/dashboard')
      }, error => {
      	toastService.showErrorToast("Cant login")
        console.log(error.response.data.message);
      });
    },
    logOut:({commit})=>{
    	console.log("Logging out");
      commit('logOut');
      clearCache();
      router.push('/login')
    }
  }
};
